<template>
  <div id="creator_country" >
    <van-row>
      <van-col span="24" :class="isFull === 1 ? 'creator_country_title_bg top_information' : ' creator_country_title_bg'">
        <van-col span="24">
          <van-nav-bar
              left-arrow
              placeholder
              class="ranking_all_bg_bar"
              @click-left="onClickLeft"
          >
            <template #title>
             {{ $t('column.Manager') }}
            </template>
            <template #right>
              <img src="../assets/img/creator/creator_country_jl.png" class="ranking_all_gift_img" @click="JumpRevenue()"/>
            </template>
          </van-nav-bar>
        </van-col>
        <van-col span="22" offset="1">
          <van-col span="6" class="creator_country_avatar">
            <van-image :src="user_info.head_image ? user_info.head_image : require('../assets/img/avatar.png')" round width="18vw" height="18vw"/>
          </van-col>
          <van-col span="18" class="creator_country_user">
            <van-col span="24" class="creator_country_user_name"> {{ user_info.nick_name }}  <img :src="user_info.country_img" v-if="user_info.country_img"/></van-col>
            <van-col span="24" class="creator_country_user_id"> ID:{{ user_info.user_id }} </van-col>
          </van-col>
           <van-col span="24" class="creator_country_user_coin">
               <div class="earning-item">
                 <div class="earning-label">{{ $t('column.Total_Earnings') }}</div>
                 <div class="earning-value">
                   <span class="amount">{{ user_info.total_earning }}</span>
                   <img src="../assets/img/coin9.png" class="coin-icon"/>
                 </div>
               </div>
               <div class="earning-divider"></div>
               <div class="earning-item">
                 <div class="earning-label">{{ $t('column.Last_Month_Earnings') }}</div>
                 <div class="earning-value">
                   <span class="amount">{{ user_info.last_month }}</span>
                   <img src="../assets/img/coin9.png" class="coin-icon"/>
                 </div>
               </div>
           </van-col>
        </van-col>
      </van-col>
      <van-col span="22" offset="1" class="creator_country_centent">
        <van-col span="22" offset="1" class="creator_country_centent_date"><span>{{ date_range }} </span></van-col>
        <van-col span="22" offset="1" class="creator_country_centent_date_title">{{ $t('column.Invite_agency_reward') }}</van-col>
        <van-col span="24" class="creator_country_centent_progress">
          <div class="progress-scroll-wrapper">
            <div class="progress-wrapper">
              <!-- 上方节点：Claim按钮和金额 -->
              <div class="progress-area">
                <div class="progress-track">
                  <div class="progress-fill" :style="{width: calculateProgressWidth() + '%'}"></div>
                  <div class="progress-dots">
                    <div class="dot" v-for="(v,j) in progress_list" :key="'dot-'+j" :style="{ left: getNodeLeftPercent2(j) }" :class="{'active': isPointActive(j)}"></div>
                  </div>
                </div>
                <div class="progress-nodes">
                  <div class="node-item" v-for="(v,j) in progress_list" :key="j" :style="{ left: getNodeLeftPercent(j) }">
                    <div class="claim-btn">{{ $t('column.claim') }}</div>
                    <div class="progress-amount">{{v.reward_amount_k }} <img src="../assets/img/creator/creator_country_fd.png" class="small-coin"/></div>
                  </div>
                </div>
              </div>
              <!-- 下方用户统计 -->
              <div class="progress-users-row">
                <div class="user-item" v-for="(v,j) in progress_list" :key="j">
                  <div class="user-count female"><img src="../assets/img/creator/creator_country_agency_icon.png" class="user-icon"/> {{v.creator_agencies}}</div>
                  <div class="user-count male"><img src="../assets/img/creator/creator_country_user_icon.png" class="user-icon"/> {{v.creator_user_per}}</div>
                </div>
              </div>
            </div>
          </div>
        </van-col>
        <van-col span="24" class="creator_country_centent_rule">
          <van-col span="18" offset="3" class="creator_country_centent_rule_text">
            <div> {{ $t('column.Invite_active_Agency_in_the_month') }}: <img src="../assets/img/creator/creator_country_agency_icon.png"/>​ {{ user_info.month_agency_sum }}</div>
            <div>{{ $t('column.join_creator_per_agency_in_the_month') }}:​ <img src="../assets/img/creator/creator_country_user_icon.png"/> {{ user_info.month_user_sum }}</div>
            <div>Need <img src="../assets/img/creator/creator_country_agency_icon.png"/> {{ user_info.next_requirement_agency }} agency and <img src="../assets/img/creator/creator_country_user_icon.png"/> {{ user_info.next_requirement_user }} creator to progress to the next claim {{ user_info.next_coin }} <img src="../assets/img/creator/creator_country_fd.png"/> </div>
          </van-col>
          <van-col span="3" class="creator_country_centent_rule_img">
            <img src="../assets/img/creator/creator_country_bz.png"/>
          </van-col>
        </van-col>
        <van-col span="24" class="creator_country_centent_type">
         <van-col span="20" class="creator_country_centent_type_text" @click="goAgencyManagement">
          <img src="../assets/img/creator/creator_country_agency_icon1.png"/>
          {{ $t('column.Agency_Management') }} ({{ user_info.agency_management }})
          </van-col>
          <van-col span="4" class="creator_country_centent_type_l">
            <van-icon name="arrow" />
          </van-col>
        </van-col>
        <van-col span="24" class="creator_country_centent_type2" @click="goUserManagement">
         <van-col span="20" class="creator_country_centent_type_text">
          <img src="../assets/img/creator/creator_country_user_icon1.png"/>
            {{ $t('column.Agency_Creator') }} ({{ user_info.agency_creator }})
          </van-col>
          <van-col span="4" class="creator_country_centent_type_l">
            <van-icon name="arrow" />
          </van-col>
        </van-col>
      </van-col>
       <van-overlay :show="overlayShow" z-index="3">
        <van-loading type="spinner" class="loading_overlay"/>
      </van-overlay>
    </van-row>
  </div>
</template>

<script>

import '@/assets/css/style.css'
import axios from "axios";
import {Toast} from "vant";

export default {
  data() {
    return {
       overlayShow: false,
      overall_progress: 0,
      progress_list:[],
      user_info:{
        agency_creator:"0",
        agency_management: "0",
        country_img: "",
        country_name: "",
        head_image: "",
        last_month: 0,
        month_agency_sum: 0,
        month_user_sum: 0,
        next_requirement_agency: 0,
        next_requirement_user: 0,
        nick_name: "",
        total_earning: 0,
        user_id: '',
        next_agency: '',
        next_user: '',
        next_coin: ''
      },
      date_range: '',
      isFull: 0, // is_full=1 全屏显示信号栏 0 非全屏显示信号栏
      nodeWidth: 60 // 每个节点的宽度
    }
  },
  computed: {
    progressWidth() {
      return this.progress_list.length * this.nodeWidth;
    }
  },
  created() {
    this.isFull = this.$route.query.is_full == 1 ? 1 : 0 // is_full=1 显示信号栏
    this.convert()
  },
  methods: {
    goAgencyManagement(){
      const token = this.$route.query.token
      this.$router.push({ path: '/creator_country_agency', query: { token: token,is_full: this.isFull } });
    },
    goUserManagement(){
      const token = this.$route.query.token
      this.$router.push({ path: '/creator_country_user', query: { token: token,is_full: this.isFull } });
    },
    onClickLeft() {
      // 拦截关闭h5
      window.location.href="bogolive://exit"
    },
    JumpRevenue(){
      const token = this.$route.query.token
      this.$router.push({ path: '/creator_country_reward_record', query: { token: token,is_full: this.isFull } });
    },
    JumpUserinfo(id) {
      console.log(id)
      if(id){
        // 拦截跳转用户主页面
        window.location.href="live://live?action=JumpUser&id=" + id
      }
    },
    getNodeLeftPercent(index) {
      const n = this.progress_list.length
      if (n <= 0) return '0%'
      const percent = ((index + 1) / n) * 100 - 10
      
      return percent.toFixed(2) + '%'
    },
    getNodeLeftPercent2(index) {
      const n = this.progress_list.length
      if (n <= 0) return '0%'
      const percent = ((index + 1) / n) * 100
      
      return percent.toFixed(2) + '%'
    },
    getNodeProgress(index) {
      const n = this.progress_list.length;
      if (n <= 0) return 0;
      return Math.round(((index + 1) / n) * 100);
    },
    isPointActive(index) {
      return this.overall_progress >= this.getNodeProgress(index);
    },
    calculateProgressWidth() {
      const p = Math.min(Math.max(this.overall_progress, 0), 100);
      const firstThreshold = this.progress_list.length > 0 ? (100 / this.progress_list.length) : 20;
      return p;
    },
    convert() {
      this.overlayShow = true
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=creator_country&act=get_creator_country_data", {
        params : {
          token: token
        }
      }).then(res =>{
        this.overlayShow = false
        if (res.data.status === 0) {
          Toast(res.data.error)
          return false
        }
        this.user_info = res.data.data.user_info
        this.date_range = res.data.data.date_range
        this.progress_list = res.data.data.invite_agency_reward
        this.overall_progress = res.data.data.progress
      })
    }
  }
}

</script>

<style>
 
</style>



// WEBPACK FOOTER //
// src/components/creator_country.vue